import { ReactNode } from "react";
import styles from "./container.module.scss";

type Props = {
  children: ReactNode;
};

const ReportContainer = ({ children }: Props) => (
  <section className={`${styles["threat-intel-report"]} flex flex-column`}>
    {children}
  </section>
);

export default ReportContainer;
